import * as React from "react";

export const IconCheckCircle = (_props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_30126_119516)">
      <path d="M11.0599 5.05301L6.66659 9.44634L4.27325 7.05967L3.33325 7.99967L6.66659 11.333L11.9999 5.99967L11.0599 5.05301ZM7.99992 1.33301C4.31992 1.33301 1.33325 4.31967 1.33325 7.99967C1.33325 11.6797 4.31992 14.6663 7.99992 14.6663C11.6799 14.6663 14.6666 11.6797 14.6666 7.99967C14.6666 4.31967 11.6799 1.33301 7.99992 1.33301ZM7.99992 13.333C5.05325 13.333 2.66659 10.9463 2.66659 7.99967C2.66659 5.05301 5.05325 2.66634 7.99992 2.66634C10.9466 2.66634 13.3333 5.05301 13.3333 7.99967C13.3333 10.9463 10.9466 13.333 7.99992 13.333Z" fill="#26A69A"/>
    </g>
    <defs>
      <clipPath id="clip0_30126_119516">
        <rect width="16" height="16" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);
